module.exports = __webpack_public_path__ + "static/lone-wolf-logo-853e87683f3624dfb2dfb3f6f0ba6d18.jpeg";